(function () {
  var wrapper = document.getElementById('ww-whatsapp-chat-wrap');
  var button = document.getElementById('ww-whatsapp-chat');
  var closeButton = document.getElementById('ww-whatsapp-close');

  if (!wrapper || !button || !closeButton) {
    return;
  }

  var dismissed = false;

  try {
    dismissed = sessionStorage.getItem('ww_whatsapp_closed') === '1';
  } catch (e) {
    dismissed = false;
  }

  if (!dismissed) {
    wrapper.hidden = false;
  }

  button.addEventListener('click', function () {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'whatsapp_chat_click',
      page_location: window.location.href,
      page_title: document.title,
      page_type: button.dataset.pageType || '',
      product_handle: button.dataset.productHandle || ''
    });
  });

  closeButton.addEventListener('click', function () {
    wrapper.hidden = true;

    try {
      sessionStorage.setItem('ww_whatsapp_closed', '1');
    } catch (e) {}

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'whatsapp_chat_dismiss',
      page_location: window.location.href,
      page_title: document.title
    });
  });
})();